export { HomePage } from '../components/pages/home'
export { SectionPage } from '../components/pages/section'
export { TagPage } from '../components/pages/tag'
export { SearchPage } from '../components/pages/search'
export { CatalogPage } from '../components/pages/catalog'
export { HomePagePreview } from '../components/pages/home-preview'
export { NotFoundPage } from '../components/pages/not-found'
export { AuthorPage } from "../components/pages/author-page.js";
export { CollectionPage } from "../components/pages/collection-page";
export { EditProfile } from "../components/pages/login-page";
export { UserDetails } from "../components/pages/user-details";
export { Subscription } from "../components/pages/subscription-page";